import { Form, LineBreak, Title, Text, TextError, Error } from "./form";
import { TARGET, useManager } from "./state";
import {
  Checkbox,
  Datebox,
  Dropdown,
  Radiogroup,
  Textbox,
  Group,
  Radiobutton,
  Searchbox,
  Divider,
  Textarea,
  Autocomplete,
  RichTextEditor,
  RichTextEditorForAnnouncements,
} from "./fields";
import { Validators } from "./validators";
import { Field } from "./fields/field";

export {
  useManager as useFormManager,
  TARGET as formManagerTarget,
  Form,
  Checkbox,
  Group,
  Datebox,
  Dropdown,
  Radiobutton,
  Radiogroup,
  Searchbox,
  Textbox,
  Validators,
  Title,
  Text,
  Divider,
  Textarea,
  Autocomplete,
  LineBreak,
  RichTextEditor,
  RichTextEditorForAnnouncements,
  Error,
};

export default Object.assign(Form, {
  useManager,
  target: TARGET,
  Checkbox,
  Group,
  Datebox,
  Dropdown,
  Radiobutton,
  Radiogroup,
  Textbox,
  Validators,
  Title,
  Text,
  Searchbox,
  Divider,
  Textarea,
  Autocomplete,
  TextError,
  Field,
  LineBreak,
  RichTextEditor,
  RichTextEditorForAnnouncements,
  Error,
});
